export const entityFormat = entity => entity === "categories" ? "category" : entity.slice(0, -1);